'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var ScrollPercentageTrigger = new _immutable.Record({
  enabled: false,
  scrollPercentage: 50
}, 'ScrollPercentageTrigger');

exports.default = ScrollPercentageTrigger;
module.exports = exports['default'];